import { setup, styled } from 'goober';
import { getRandomInt } from 'mc-ui-utils';
import React, { forwardRef, Fragment, useCallback, useEffect, useRef, useState, } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Floater from './Floater';
setup(React.createElement);
const Holder = styled('div', forwardRef) `
  background: transparent;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  align-content: center;
  position: relative;
  height: 100vh;
`;
const StickerTray = ({ stickerList = [] }) => {
    const containerRef = useRef(null);
    const [floaters, setFloaters] = useState([]);
    const onFloaterShowEnd = useCallback((id) => {
        let newFloaters = [];
        if (id) {
            newFloaters = floaters.filter((f) => f.id !== id);
        }
        setFloaters(newFloaters);
    }, [floaters, setFloaters]);
    /**
     * This component is picked from astral
     * https://github.tools.inmobi.com/glance/astral/blob/develop/src/components/StickerTray/index.tsx
     */
    useEffect(() => {
        let timeout;
        if (!floaters.length) {
            timeout = window.setTimeout(() => {
                const arrLen = getRandomInt(6, 10);
                const newFloaters = [];
                for (let i = 0; i < arrLen; i++) {
                    const id = uuidv4();
                    const sticker = stickerList[getRandomInt(0, stickerList.length - 1)];
                    const parentEle = containerRef.current;
                    const initialPosition = {
                        x: parentEle.clientWidth / 2 + (39 * (stickerList.length - 1)) / 2,
                        y: 100,
                    };
                    const parentDimention = {
                        x: parentEle.offsetLeft,
                        y: parentEle.offsetTop,
                        width: parentEle.clientWidth,
                        height: parentEle.clientHeight,
                    };
                    const floater = {
                        sticker,
                        id,
                        isActiveFloater: false,
                        initialPosition,
                        parentDimention,
                        animDelay: getRandomInt(100, 1500),
                    };
                    newFloaters.push(floater);
                }
                setFloaters(newFloaters);
            }, getRandomInt(1, 2) * 1000);
        }
        return () => clearTimeout(timeout);
    }, [floaters, setFloaters, stickerList]);
    return (React.createElement(Fragment, null,
        React.createElement(Holder, { ref: containerRef }, floaters.map((floater) => (React.createElement(Floater, { key: floater.id, sticker: floater.sticker, id: floater.id, onShowEnd: onFloaterShowEnd, isActiveFloater: floater.isActiveFloater, parentDimention: floater.parentDimention, initialPosition: floater.initialPosition, animDelay: floater.animDelay }))))));
};
export default StickerTray;
//# sourceMappingURL=index.js.map